import React, { useState, useRef, useEffect, useMemo } from "react";
import {
	Modal,
	Form,
	Row,
	Col,
	Overlay,
	Popover,
	Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import Flatpickr from "react-flatpickr";
import { fetchCityData, selectCity, clearCityList } from "../../redux/actions/citiesAction";
import {
	fetchIndustryData,
	setSelectedIndustry,
} from "../../redux/actions/industryActions";
import { useDispatch, useSelector } from "react-redux";

import { customStyles } from "../../selectStyles";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import {
	fetchInstituteData,
	selectGetInstitute,
} from "../../redux/actions/getInstitutesAction";
import { useParams } from "react-router-dom";
import {
	fetchSpecialization,
	selectSpecialization,
} from "../../redux/actions/specializationAction";
import {
	fetchQualification,
	selectQualification,
} from "../../redux/actions/qualificationAction";
import moment from "moment/moment";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { fetchAllOrgsData } from "../../redux/actions/getAllOrgsAction";
import { fetchOrgRegdInsData } from "../../redux/actions/getRegdInsAction";
import { verify } from "../../assets/images/verify.webp";


const AddEducation = ({ show, handleClose, userDataId, userDataInfo, getUserCv }) => {
	const sessionId = localStorage.getItem("sessionId");
	const userType = localStorage.getItem("userType");
	const { CandidateId } = useParams();
	console.log("userDataId", userDataId);
	const [display, setDisplay] = useState(false);
	const dispatch = useDispatch();

	const [field, setField] = useState("");
	const [AcademicAchiv, setAcademicAchiv] = useState("");
	const [grade, setGrade] = useState("");
	const [isPresent, setIsPresent] = useState(false);
	const [description, setDescription] = useState("");
	const [activities, setActivities] = useState("");
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [showTooltip, setShowTooltip] = useState(false);
	const targetRef = useRef(null);
	const [newEducation, setNewEducation] = useState("");
	const [OrganizationName, setOrganizationName] = useState("");
	const [InsName, setInsName] = useState("");
	const [company, setCompany] = useState(1)
	const [institude, setInstitute] = useState(2)

	// .......................... Edit-Candid Disabled and Enabaled
	const [formChanged, setFormChanged] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);


	const handleFieldChange = (setter, value, fieldName) => {
		setter(value);

		// Ensure values are strings (avoid .trim() errors)
		const updatedInstituteId = fieldName === "instituteId" ? String(value || "") : String(instituteId || "");
		const updatedQualification = fieldName === "qualification" ? String(value || "") : String(qualification || "");
		const updatedCitySearch = fieldName === "citySearch" ? String(value || "") : String(citySearch || "");
		const updatedSpecialization = fieldName === "specialization" ? String(value || "") : String(specialization || "");
		const updatedStartDate = fieldName === "startDate" ? String(value || "") : String(startDate || "");
		const updatedEndDate = fieldName === "endDate" ? String(value || "") : String(endDate || "");
		const updatedIsPresent = fieldName === "isPresent" ? value : isPresent;

		// Check if all required fields are filled
		const allFieldsFilled =
			updatedInstituteId.trim() !== "" &&
			updatedQualification.trim() !== "" &&
			updatedCitySearch.trim() !== "" &&
			updatedSpecialization.trim() !== "" &&
			updatedStartDate.trim() !== "" &&
			(updatedIsPresent || updatedEndDate.trim() !== "");

		setFormChanged(allFieldsFilled);
	};



	// ..............................  Edit-Candid Disabled and Enabaled


	// const handleSubmit = async (e) => {
	// 	e.preventDefault();
	// 	setDisplay(true);
	// 	setIsSubmitting(true); // Disable the button during submission
	// 	if (
	// 		// cityId === "" ||
	// 		// jobTypeSearch === "" ||
	// 		// workLevelId === "" ||
	// 		// workLocationSearch === "" ||
	// 		// designationSearch === "" ||
	// 		// salaryTypeSearch === "" ||
	// 		// minimumSalary === "" ||
	// 		// maximumSalary === "" ||
	// 		// requirement === null ||
	// 		// currency === "" ||
	// 		// jobTitle === "" ||
	// 		// jobDescription === ""
	// 		""
	// 	) {
	// 		toast.error("Please fill all the required fields");
	// 		setIsSubmitting(false); // Re-enable the button if validation fails
	// 	} else {
	// 		let institutionId = 0;
	// 		let orgType = 0;
	// 		let gnrlOrgInsttnId = 0;


	// 		if (instituteId) {
	// 			institutionId = regdType === 4 ? null : instituteId;
	// 			orgType = regdType === 4 ? 4 : regdType;
	// 			gnrlOrgInsttnId = regdType === 4 ? instituteId : null;
	// 		}
	// 		else
	// 			if (getOrgInsTId) {
	// 				institutionId = null;
	// 				orgType = 4;
	// 				gnrlOrgInsttnId = getOrgInsTId;
	// 			}

	// 		const body = {
	// 			sessionId: sessionId,
	// 			userDataId: userDataId,
	// 			userType: userType,
	// 			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,

	// 			institutionId,
	// 			orgType,
	// 			gnrlOrgInsttnId,

	// 			startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
	// 			startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
	// 			endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
	// 			endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
	// 			qualification: qualification,
	// 			specilization: specialization,
	// 			grade: grade,
	// 			description: description,
	// 			cityId: citySearch,
	// 			isPresent: isPresent,

	// 		};

	// 		console.log("body", body);

	// 		if (
	// 			(institutionId === 0 && gnrlOrgInsttnId === 0) ||
	// 			(orgType === 0) ||

	// 			startDate === ""
	// 		) {
	// 			toast.error("Please fill all the required fields");
	// 			setIsSubmitting(false); // Re-enable the button if validation fails
	// 		} else {
	// 			try {
	// 				const res = await axios.post("/Resume/AddEducation", body);
	// 				console.log("res=====>", res);

	// 				toast.success(res.data.message);
	// 				handleClose();
	// 				setInsName("");
	// 				getUserCv();
	// 				resetForm();
	// 			}
	// 			catch (error) {
	// 				if (error.response && error.response.status === 404) {
	// 					toast.error(error.response.data.message);
	// 				} else {
	// 					toast.error(error.response?.data?.title);
	// 				}
	// 			}
	// 			finally {
	// 				setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
	// 			}
	// 		}

	// 	}
	// 	// Applying conditions for institution fields
	// };

	const handleSubmit = async (e) => {
		e.preventDefault();
		setDisplay(true);
		setIsSubmitting(true); // Disable the button during submission

		// Validation block
		if (
			(instituteId === "" && getOrgInsTId === "") ||
			qualification === "" ||
			specialization === "" ||
			// (!isPresent || endDate === "") || // If not present, endDate is required
			citySearch === "" ||
			startDate === "" ||
			(startDate && !isPresent && !endDate)
			// grade === "" ||
			// description === ""
		) {
			toast.error("Please fill all the required fields");
			setIsSubmitting(false); // Re-enable the button if validation fails
			return;
		}

		// Institution values preparation
		let institutionId = 0;
		let orgType = 0;
		let gnrlOrgInsttnId = 0;

		if (instituteId) {
			institutionId = regdType === 4 ? null : instituteId;
			orgType = regdType === 4 ? 4 : regdType;
			gnrlOrgInsttnId = regdType === 4 ? instituteId : null;
		} else if (getOrgInsTId) {
			institutionId = null;
			orgType = 4;
			gnrlOrgInsttnId = getOrgInsTId;
		}

		const body = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: userType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,

			institutionId,
			orgType,
			gnrlOrgInsttnId,

			startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
			startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
			endYear: isPresent ? null : (endDate ? moment(endDate).format("YYYY") : null),
			endMonth: isPresent ? null : (endDate ? moment(endDate).format("MM") : null),
			qualification: qualification,
			specilization: specialization,
			grade: grade,
			description: description,
			cityId: citySearch,
			isPresent: isPresent,
		};

		console.log("body", body);

		try {
			const res = await axios.post("/Resume/AddEducation", body);
			console.log("res=====>", res);

			toast.success(res.data.message);
			handleClose();
			setInsName("");
			getUserCv();
			resetForm();
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.title || "An error occurred");
			}
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
	};


	const [getOrgInsTId, setGenOrgInstId] = useState(null);
	const [newOrgType, setnewOrgType] = useState(null);

	const handleSaveInstitution = async () => {
		// setDisplay(true);

		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdInstitution");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			console.log("res", res);
			const newOrg = {
				value: res.data.responseData.id,
				label: OrganizationName,
				tagId: 4,
			};
			dispatch(fetchOrgRegdInsData());
			// setGenOrgInstId(res.data.responseData.id);
			setInstituteId(res.data.responseData.id)
			setnewOrgType(res.data.responseData.value);
			toast.success(`${res.data.message} The newly created institution is now available at the top of the dropdown. Please select it.`);
			//setShowTooltip(false);


			setOrganizationName("");
			setInsName("")
			setOrgCity(null)
			setFileName("");
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};
	// ...............................City DDL.......................................
	const [orgCity, setOrgCity] = useState(null);
	const [citySearch, setCitySearch] = useState("");


	const [searchTerm, setSearchTerm] = useState("")
	const [cityNameOption, setCityNameOption] = useState([])

	const getCityList = async (pageNumber = 1, pageSize = 10) => {
		try {
			const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
				pageNumber,
				pageSize
			})
			console.log("Get City Name List==>", response)
			const cityList = response.data.responseData.citiesDDL.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setCityNameOption(cityList)
		}
		catch (error) {
			//toast.error(error.message || 'Something went wrong while fetching city data',)
		}
	}

	useEffect(() => {
		getCityList();
	}, [searchTerm]);


	const handleCitySelect = (selectedOption) => {
		setCitySearch(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};
	const handleCitySelectOrg = (selectedOption) => {
		setOrgCity(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};
	// ...............................City DDL.......................................

	// ...............................Specialization DDL.......................................
	const [specialization, setSpecialization] = useState("");
	const { SpecializationList, selectedSpecializationId } = useSelector(
		(state) => state.specialization
	);
	useEffect(() => {
		dispatch(fetchSpecialization());
	}, [dispatch]);

	const handleSpecializationSelect = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectSpecialization(selectedOption.value));
			setSpecialization(selectedOption.label);
			// dispatch(selectSpecialization(selectedOption.label));
		} else {
			setSpecialization(null);

		}
	};

	// ...............................Qualification DDL.......................................
	const [qualification, setQualification] = useState("");
	const { qualficationList, selectedqualficationId } = useSelector(
		(state) => state.qualification
	);

	useEffect(() => {
		dispatch(fetchQualification());
	}, [dispatch]);
	// const handleQualificationSelect = (selectedOption) => {
	// 	if (selectedOption) {
	// 		// dispatch(selectQualification(selectedOption.value));
	// 		setQualification(selectedOption.label);
	// 	} else {
	// 		setQualification(null);

	// 	}
	// };

	// ...............................Institute DDL.......................................
	const [regdType, setRegdType] = useState("");
	const [orgType, setOrgType] = useState("");
	const [instituteId, setInstituteId] = useState(null);
	const { getallorgsList, selectedinstituteId } = useSelector(
		(state) => state.getRegdIns
	);

	const reversedOrgList = useMemo(() => {
		return [...getallorgsList].reverse(); // Create a new reversed copy
	}, [getallorgsList]);


	useEffect(() => {
		// dispatch(fetchAllOrgsData());
		dispatch(fetchOrgRegdInsData());
	}, [dispatch]);
	console.log("getallorgsList", getallorgsList);


	const handleInstitute = (selectedOption) => {
		// console.log("selectedOption", selectedOption);

		if (selectedOption) {
			// dispatch(selectGetInstitute(selectedOption.value));
			setInstituteId(selectedOption.value);
			setOrgType(selectedOption.tagId);
			setRegdType(selectedOption.tagId);
		} else {
			setInstituteId(null);
			setRegdType(null)
		}
	};

	const toggleTooltip = () => {
		setShowTooltip((prev) => !prev);
	};
	// ...............................Institute DDL.......................................

	const [fileName, setFileName] = useState(""); // State to store selected filename
	const handleFileChange = (event) => {
		const file = event.target.files[0]; // Get the selected file
		if (file) {
			setFileName(file.name); // Set the filename in state
		}
	};

	const resetForm = () => {
		setAcademicAchiv("");
		setActivities("");
		setGrade("");
		setDescription("");
		setStartDate(null);
		setEndDate(null);
		setQualification("");
		setSpecialization("");
		setCitySearch("");
		//setOrgCity("");
		setInstituteId("");
		setInsName("");
		setDisplay(false);
		setIsPresent(false);
		setFormChanged(false);
	};

	const handleCloseEducation = () => {
		resetForm(); // Call resetForm when closing the modal
		handleClose();
	};

	const handleSpecializationChange = (inputValue, { action }) => {
		if (action === "input-change") {
			setSpecialization(inputValue);
		}
	};

	const handleQualificationChange = (inputValue, { action }) => {
		if (action === "input-change") {
			setQualification(inputValue);
		}
	};

	return (
		<Modal
			show={show}
			onHide={handleCloseEducation}
			centered
			size="lg"
			className="add-education"
		>
			<Modal.Header>
				<Modal.Title>Add education</Modal.Title>
				<CloseSharpIcon className="pointer" onClick={handleCloseEducation} />
			</Modal.Header>
			<Modal.Body className="settings">
				<Row>
					{/* Institution and City */}
					<Col md={6} className="mb-2">
						<Form.Group controlId="institution">
							<Form.Group controlId="Industry">
								<Form.Label className="class-type">
									Institute
									<span className="text-red"> *</span>
								</Form.Label>
								{InsName !== "" ? (
									<div>
										<input
											type="text"
											value={InsName}
											placeholder=" Org name"
											className="mb-2 Enterform-control Dark-Input-from-group"
											disabled
										/>
									</div>
								) : (
									<div className="post-form-group mb-0">
										<ReactSelect
											options={reversedOrgList}
											onChange={(option) => {
												handleFieldChange(handleInstitute, option);
												// handleFieldChange(setInstituteId, option ? option.value : "", "instituteId");
												// setOrgType(option ? option.tagId : null);
												// setRegdType(option ? option.tagId : null);
											}}
											getOptionValue={(option) => `${option.value}-${option.tagId}`}
											//value={getallorgsList.find((option) => option.value === instituteId) || null} 
											value={
												reversedOrgList.find((
													(option) => {
														if (InsName !== "" && InsName !== null) {
															return option.value === InsName;
														} else {
															return option.value === instituteId && option.tagId === regdType
														}
													}
												))
											}
											placeholder="Select institute"
											classNamePrefix="react-select"
											className="form-control Dark-Input-from-group"
											formatOptionLabel={(option) => (
												<div style={{ fontWeight: option.tagId === 1 ? "bold" : "normal" }}>
													{option.label}
												</div>
											)}
											styles={customStyles}
											isClearable
										/>


									</div>
								)}
							</Form.Group>
							{display && !instituteId ? (
								<span className="error_msg_lbl">Select Institute </span>
							) : null}
							<a
								href="#"
								ref={targetRef}
								onClick={(e) => {
									e.preventDefault();
									toggleTooltip();
								}}
								className="createModal"
							// isDisabled={!selectedIndustryId} // Disable until industry is selected
							>
								Create new
							</a>
							<Overlay
								target={targetRef.current}
								show={showTooltip}
								placement="right"
								rootClose
								container={document.querySelector(".modal")}
								onHide={() => setShowTooltip(false)} // Close when clicking outside
							>
								<Popover id="popover-basic" className="overlay-popover-modal" >
									<Popover.Header as="h3" className="Dark-Body-Card-group">Create Institute</Popover.Header>
									<Popover.Body className="Dark-Body-Card-group">
										<Form>

											<div className="create-comp-style">
												<label className="mb-1 Text-mb-Create">Institute name</label>
												<input
													type="text"
													value={OrganizationName}
													// onChange={(e) => {
													// 	setOrganizationName(e.target.value);
													// 	setInsName(e.target.value);
													// }}
													onChange={(e) => {
														setOrganizationName(e.target.value);
														setInsName(e.target.value);
														setInstituteId(e.target.value); //  Ensure instituteId is updated
														handleFieldChange(setInstituteId, e.target.value, "instituteId"); // Trigger validation
													}}
													placeholder="Enter institute name"
													className="mb-2 form-control Dark-Input-from-group"
												/>
											</div>

											<div className="create-comp-style">
												<label className="mb-1 Text-mb-Create">City</label>
												<ReactSelect
													options={cityNameOption}
													onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
													onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
													placeholder="Search & select city"
													classNamePrefix="react-select"
													className="form-control Dark-Input-from-group"
													styles={customStyles}
													isClearable
												/>
											</div>

											<div className=" mt-2 mb-2 Text-mb-Create">
												<label className="mb-1">Institute logo</label>
												<input
													type="file"
													id="lastName"
													className="form-control Dark-Input-from-group"
													placeholder=""
													onChange={handleFileChange}
												/>
											</div>
											<div className="d-flex justify-content-end">
												<Button
													variant="primary"
													size="sm"
													//onClick={handleSaveInstitution}
													onClick={() => {
														handleSaveInstitution()
														setShowTooltip(false)
													}
													}
													className="me-2"
												>
													Save
												</Button>
												<Button
													variant="secondary"
													size="sm"
													onClick={() => setShowTooltip(false)}
												>
													Cancel
												</Button>
											</div>
										</Form>
									</Popover.Body>
								</Popover>
							</Overlay>
						</Form.Group>
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">
								City
								<span className="text-red"> *</span>
							</Form.Label>
						</Form.Group>
						<div className="post-form-group mb-0">
							<ReactSelect
								options={cityNameOption}
								onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
								// onChange={handleCitySelect} // Select hone ke baad clear ho jaye
								onChange={(option) => handleFieldChange(setCitySearch, option ? option.value : "", "citySearch")} // Track changes
								placeholder="Search & select city"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>
						{/* {display && !citySearch ? (
              <span className="error_msg_lbl">Search & Select City </span>
            ) : null} */}
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">
								Specialization
								<span className="text-red"> *</span>
							</Form.Label>
						</Form.Group>
						<div className="post-form-group post-form-fontEdu mb-0">
							<ReactSelect
								options={SpecializationList}

								onInputChange={handleSpecializationChange}
								// onChange={(option) => handleFieldChange(setSpecialization, option ? option.label : "")} 
								onChange={(option) => handleFieldChange(setSpecialization, option ? option.label : "", "specialization")}
								value={
									SpecializationList.find((option) => option.label === specialization) ||
									(specialization ? { label: specialization, value: specialization } : null)
								}
								placeholder="Select specialization"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>

					</Col>
					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">
								Qualification
								<span className="text-red"> *</span>
							</Form.Label>
						</Form.Group>
						<div className="post-form-group post-form-fontEdu mb-0">
							<ReactSelect
								options={qualficationList}

								onInputChange={handleQualificationChange}
								// onChange={(option) => handleFieldChange(setQualification, option ? option.label : "")}
								onChange={(option) => handleFieldChange(setQualification, option ? option.label : "", "qualification")}
								value={
									qualficationList.find((option) => option.label === qualification) ||
									(qualification ? { label: qualification, value: qualification } : null)
								}

								placeholder="Select specialization"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>

					</Col>

					<Col md={6} className="mb-2 mt-2">
						<Form.Group controlId="grade">
							<Form.Label className="class-type">Grade</Form.Label>
							<Form.Control
								type="text"
								value={grade}
								className="custom-style Dark-Input-from-group"
								onChange={(e) => setGrade(e.target.value)}
								// onChange={(e) => handleFieldChange(setGrade, e.target.value)}
								placeholder="Enter grade"
							/>
							{/* {display && !grade ? (
                <span className="error_msg_lbl">Select Grade </span>
              ) : null} */}
						</Form.Group>
					</Col>

					{/* <Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type mt-2">
								Qualification
								<span className="text-red"> *</span>
							</Form.Label>
						</Form.Group>
						<div className="post-form-group mb-0">
							<ReactSelect
								options={qualficationList}
								onChange={(option) => handleFieldChange(setQualification, option ? option.label : "")}
								value={
									qualficationList.find(
										(option) => option.label === qualification
									) || null
								}
								placeholder="Select Qualification"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>
						
					</Col> */}

					<Col md={6} className="mb-2 mt-2">
						<Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
							<Form.Label className="class-type  col-md-12">
								Start year
								<span className="text-red"> *</span>
							</Form.Label>
							<Flatpickr
								type="number"
								className="custom-style Dark-Input-from-group"
								// onChange={(date) => setStartDate(date[0])}
								// onChange={(date) => handleFieldChange(setStartDate, (date[0]))} // Track changes
								onChange={(date) => handleFieldChange(setStartDate, date[0], "startDate")}
								placeholder="Enter start year"
								invalid={display && startDate === ""}
								value={startDate}
								options={{
									maxDate: new Date(),
									static: true, // Keeps the calendar visible on click         
								}}
							// disabled={isPresent}
							/>
						</Form.Group>
						{display && !startDate ? (
							<span className="error_msg_lbl">Enter Start Year</span>
						) : null}
					</Col>
					{/* {userDataInfo.isPresentEducation === true ? (
						""
					) : ( */}
					<Col md={6} className="d-flex align-items-center mb-2">
						<Form.Check
							type="checkbox"
							label="Is Present"
							checked={isPresent}
							onChange={(e) => handleFieldChange(setIsPresent, e.target.checked, "isPresent")}
						/>

					</Col>
					{/* )} */}

					{isPresent === false ? (
						<Col md={6} className="mb-2 mt-2">
							<Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
								<Form.Label className="class-type  col-md-12">
									End year
									<span style={{ color: "red" }} className="ms-2">*</span>
								</Form.Label>
								<Flatpickr
									type="number"
									value={endDate}
									// onChange={(date) => setEndDate(date[0])}
									// onChange={(date) => handleFieldChange(setEndDate, (date[0]))}
									onChange={(date) => handleFieldChange(setEndDate, date[0], "endDate")}
									placeholder="Enter end year"
									disabled={isPresent}
									className="custom-style Dark-Input-from-group"
									options={{
										minDate: startDate || null,
										static: true, // Keeps the calendar visible on click         
									}}
								/>
								{/* {display && !endDate ? (
                  <span className="error_msg_lbl">Enter End Year</span>
                ) : null} */}
							</Form.Group>
						</Col>
					) : (
						""
					)}

					{/* Description */}
					<Col md={12} className="mb-2">
						<Form.Group controlId="description">
							<Form.Label className="class-type">Description</Form.Label>
							<Form.Control
								as="textarea"
								rows={3}
								value={description}
								className="custom-style Dark-Input-from-group"
								// onChange={(e) => setDescription(e.target.value)}
								onChange={(e) => handleFieldChange(setDescription, e.target.value)}
								placeholder="Enter description"
							/>
						</Form.Group>
					</Col>
				</Row>

				{/* Submit Button */}
				<div className="d-flex justify-content-end mt-4">
					<div className="add-class-submit-button mt-4 d-flex justify-content-center">
						<div className="khojPrimaryBtn ms-3"
							onClick={handleSubmit}
							style={{ cursor: formChanged ? "pointer" : "default" }}
						>
							<a href="#/"
								// className=""
								// onClick={handleSubmit}
								className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
								disabled={!formChanged || isSubmitting}
								style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
							>
								Submit
							</a>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};


export default AddEducation;
